import React, {useState, useEffect} from 'react';
import "./BoxMessageTemplate.sass";
import campaignApi from "../../../api/campaign.api";
import ModalSendTemplateMarketing from "../../../pages/Campaign/components/Block/ModalSendTemplateMarketing"
import {useSelector} from "react-redux";
import { Card, Space, List, Image } from 'antd';

const BoxMessageTemplateMarketing = ({setShowDialog}) => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [templateId, setTemplateId] = useState("");

    useEffect(() => {
        getTemplateList();
    }, []);

    const getTemplateList = async () => {
        setLoading(true);
        
        try{
            let res = await campaignApi.getMessageTemplate('');
            let data = res.data.data;
            setTemplates(data);
            setLoading(false);
        }
        catch(ex){
            setLoading(false);
        }
    }

    const showEditTemplate = (id) => {
        setTemplateId(id);
        setShowModal(true);
    }

    return (
        <div className="box-template-wrap text-center">
            <ModalSendTemplateMarketing showModal={showModal} setShowModal={setShowModal} templateId={templateId}/>
            <Space direction="vertical" size={16}>
                <Card title="Tin nhắn mẫu marketing" size="small" bordered={false} style={{ width: 500 }}>
                    <List
                        itemLayout="horizontal"
                        dataSource={templates}
                        renderItem={(item, index) => (
                        <List.Item onClick={() => showEditTemplate(item._id)} style={{ cursor: 'pointer' }}>
                            <List.Item.Meta
                            avatar={<Image style={{ width: '45px', marginRight: '10px', borderRadius: '5px' }} src={item.thumbnail} />}
                            title={<div style={{ cursor: 'pointer' }}>{item.template_name}</div>}
                            description={item.description}
                            />
                        </List.Item>
                        )}
                    />
                </Card>
            </Space>
        </div>
    );
}

export default BoxMessageTemplateMarketing;
